(() => {
  const SELECTOR = '[data-troy-social-overview]';
  const DESKTOP_MQ = window.matchMedia('(min-width: 990px)');
  const REDUCE_MOTION_MQ = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (root) => {
    if (root.dataset.troyInit === '1') return;
    root.dataset.troyInit = '1';

    const cells = Array.from(root.querySelectorAll('[data-troy-social-cell]'));
    const phones = cells.map((c) => c.querySelector('[data-troy-phone]'));
    const track = root.querySelector('[data-troy-social-track]');
    const dots = Array.from(root.querySelectorAll('[data-troy-dot]'));

    /* ---------- Desktop: independent scroll parallax + zigzag + tilt ---------- */
    let rafId = null;
    let ticking = false;

    const applyTransforms = () => {
      ticking = false;
      const desktop = DESKTOP_MQ.matches && !REDUCE_MOTION_MQ.matches;
      const vh = window.innerHeight || 800;
      const viewportCenter = vh / 2;

      for (let i = 0; i < cells.length; i++) {
        const cell = cells[i];
        const phone = phones[i];
        if (!phone) continue;

        if (!desktop) {
          phone.style.transform = '';
          continue;
        }

        const baseOffset = parseFloat(cell.dataset.baseOffset || '0');
        const tilt = parseFloat(cell.dataset.tilt || '0');
        const speed = parseFloat(cell.dataset.parallaxSpeed || '0');

        const rect = cell.getBoundingClientRect();
        const cellCenter = rect.top + rect.height / 2;
        const dist = cellCenter - viewportCenter;
        const offset = dist * speed;

        phone.style.transform =
          `translate3d(0, ${baseOffset + offset}px, 0) rotate(${tilt}deg)`;
      }
    };

    const requestApply = () => {
      if (ticking) return;
      ticking = true;
      rafId = window.requestAnimationFrame(applyTransforms);
    };

    window.addEventListener('scroll', requestApply, { passive: true });
    window.addEventListener('resize', requestApply);
    DESKTOP_MQ.addEventListener('change', requestApply);
    REDUCE_MOTION_MQ.addEventListener('change', requestApply);
    requestApply();

    /* ---------- Mobile: pagination dots tied to scroll position ---------- */
    if (track && dots.length) {
      const setActive = (idx) => {
        dots.forEach((d, i) => {
          if (i === idx) {
            d.setAttribute('aria-current', 'true');
          } else {
            d.removeAttribute('aria-current');
          }
        });
      };

      if ('IntersectionObserver' in window) {
        const visibility = new Map();
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              visibility.set(entry.target, entry.intersectionRatio);
            });
            let bestIdx = 0;
            let bestRatio = -1;
            cells.forEach((c, i) => {
              const r = visibility.get(c) || 0;
              if (r > bestRatio) {
                bestRatio = r;
                bestIdx = i;
              }
            });
            setActive(bestIdx);
          },
          { root: track, threshold: [0.25, 0.5, 0.75, 1] }
        );
        cells.forEach((c) => io.observe(c));
      } else {
        setActive(0);
      }

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          const target = cells[i];
          if (!target) return;
          target.scrollIntoView({
            behavior: REDUCE_MOTION_MQ.matches ? 'auto' : 'smooth',
            inline: 'center',
            block: 'nearest',
          });
        });
      });
    }
  };

  const initAll = () => {
    document.querySelectorAll(SELECTOR).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector(SELECTOR);
    if (root) init(root);
  });
})();
